import CityPageTemplate from "../city-template/CityPageTemplate";
import { greenwoodConfig } from "./data";

export default function GreenwoodInPage() {
  return <CityPageTemplate config={greenwoodConfig} />;
}